import React, { useEffect, useMemo, useState } from "react";
import { MenuCategoryModel } from "../../../services/menu_categories/models/menu_category.model";
import { useSelector } from "react-redux";
import { getCompanyId } from "../../../react-reduxs/slices/auth/auth_slice";
import { Button, Col, Form, Input, Row, Space, Switch } from "antd";
import Title from "antd/es/typography/Title";
import FileUploadComponent from "../../tests/FileUploadComponent";
import { getCompany } from "../../../react-reduxs/slices/companies/company_slice";

interface CompManagerMenuCategoryAddProps {
  modalClose?: () => void;
  saveCategory: (value: any) => Promise<void>;
  isLoading: boolean;
  categoryModel?: MenuCategoryModel;
}

const CompManagerMenuCategoryAdd: React.FC<CompManagerMenuCategoryAddProps> = ({
  saveCategory,
  modalClose = () => {},
  isLoading,
  categoryModel,
}) => {
  const company = useSelector(getCompany);
  const companyId = useSelector(getCompanyId);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [form] = Form.useForm();
  const onFinish = async (values: any) => {
    if (companyId !== "") {
      await saveCategory({
        companyId: companyId,
        ...values,
        id: values.id == "" ? null : values.id,
        topCategoryId: values.topCategoryId == "" ? null : values.topCategoryId,
        photo: imageUrl === "" ? undefined : imageUrl,
        index: 0,
      });

      modalClose();
    }
  };

  const [imageUrl, setImageUrl] = useState("");
  useEffect(() => {
    if (categoryModel) {
      form.setFieldValue("id", categoryModel.id);
      form.setFieldValue("name", categoryModel.name);
      form.setFieldValue("status", categoryModel.status);

      if (categoryModel.photo !== undefined) {
        setImageUrl(categoryModel.photo);
      } else {
        setImageUrl("");
      }
    }

    return () => {};
  }, [categoryModel, form]);

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Row style={{ gap: 3 }}>
          <Col flex={1}>
            <Title style={{ lineHeight: 0 }} level={3}>
              Kategori Ekle
            </Title>
            <Form.Item name="id" label="" initialValue={categoryModel?.id ?? 0}>
              <Input placeholder="" style={{ display: "none" }} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="status" label="" initialValue={true}>
              <Switch checkedChildren="Aktif" unCheckedChildren="Pasif" />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ gap: 3 }}>
          <Col flex={1}>
            <Form.Item name="name" label="Adı" rules={[{ required: true }]}>
              <Input placeholder="Adı" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <FileUploadComponent
              path={"Companies/" + company?.folderName + "/Categories"}
              imageUrlP={imageUrl}
              setImageUrlParam={setImageUrl}
              setDeleteImageParam={setDeleteStatus}
            />
          </Col>
        </Row>
        <Form.Item>
          <Space>
            <Button
              disabled={isLoading}
              loading={isLoading}
              type="primary"
              htmlType="submit"
            >
              Kaydet
            </Button>
          </Space>
        </Form.Item>
      </Form>
      <Button
        loading={isLoading}
        disabled={deleteStatus || isLoading}
        danger
        onClick={() => {
          modalClose();
        }}
      >
        İptal
      </Button>
    </div>
  );
};

export default CompManagerMenuCategoryAdd;
